export default __webpack_public_path__ + "static/media/Python-logo-notext.063da199.svg";